import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import ModalWrapper from 'components/Modals/ModalWrapper';
import PoweredBy from 'components/PoweredBy';

import {
  closeAboutModal,
  getApiStatus,
} from 'actions';

const AboutModal = () => {
  const dispatch = useDispatch();
  const version = useSelector(state => state.common?.apiStatus);

  useEffect(() => {
    dispatch(getApiStatus());
  }, []);

  return (<ModalWrapper
    headerClose
    isOpen
    title="About"
    btnConfirmTitle="Close"
    showCancel={ false }
    onConfirm={ () => dispatch(closeAboutModal()) }
    onCancel={ () => dispatch(closeAboutModal()) }
  >
    <div className="columns">
      <div className="col-12">
        <div className="about-logo" />
        <PoweredBy />
        <h1 className="taina-brand text-center mt">
          T<span className="taina-ai">AI</span>NA Fully Automated Tax Form Validator and Classifier
        </h1>
        <p className="mb-2rem"><strong>Version:</strong> <span className="app-version" /></p>
      </div>
      { version && <React.Fragment>
        <div className="col-12 mb-2rem">
          <strong>Status: </strong>{ version.Status }
        </div>
        <div className="col-12">
          <strong>API Versions</strong>
          <div className="col-6 columns ml-2rem">
            { version.Assemblies && Object.keys(version.Assemblies).map(x => <React.Fragment key={ x }>
              <div className="col-6">{ x }</div>
              <div className="col-6">{ version.Assemblies[x] }</div>
            </React.Fragment>)}
          </div>
        </div>
      </React.Fragment> }
    </div>
  </ModalWrapper>);
};

export default AboutModal;
